import { Component } from 'react';
import { dateNow } from 'utils/core/now';

export interface ITimerProps {
  startDate: Date;
  duration: number;
  children?: any;
  onTimerEnded?: () => void;
}

interface ITimerState {
  timeLeft: number;
  interval?: any;
}

export interface ITimerChildrenProps {
  timeLeft: number;
  elapsedTime: number;
}

const initialTimerState: ITimerState = {
  timeLeft: 0,
};

export class Timer extends Component<ITimerProps, ITimerState> {
  constructor(props: ITimerProps) {
    super(props);
    this.state = { ...initialTimerState };
  }

  public render() {
    const childProps: ITimerChildrenProps = {
      timeLeft: this.state.timeLeft,
      elapsedTime: this.props.duration - this.state.timeLeft,
    };

    return this.props.children && this.props.children(childProps);
  }

  public componentDidMount() {
    this.start();
  }

  public componentDidUpdate(prevProps: ITimerProps) {
    if (
      prevProps.duration !== this.props.duration ||
      prevProps.startDate.getTime() !== this.props.startDate.getTime()
    ) {
      this.start();
    }
  }

  public componentWillUnmount() {
    clearInterval(this.state.interval);
  }

  private start() {
    this.stop();
    if (this.getTimeLeft() > 0) {
      const interval = setInterval(this.updateTimeLeft, 1000);
      this.setState({
        interval,
        timeLeft: this.props.duration,
      });
    } else {
      if (this.props.onTimerEnded) {
        this.props.onTimerEnded();
      }
    }
  }

  private stop() {
    this.setState({ timeLeft: 0 });
    if (this.state.interval) {
      clearInterval(this.state.interval);
    }
  }

  private getTimeLeft(): number {
    const currentDuration: number = dateNow() - new Date(this.props.startDate).getTime();
    return this.props.duration - currentDuration;
  }

  private updateTimeLeft = () => {
    const currentTimeLeft: number = this.getTimeLeft();

    if (currentTimeLeft <= 0) {
      this.stop();
      if (this.props.onTimerEnded) {
        this.props.onTimerEnded();
      }
    } else {
      this.setState({ timeLeft: currentTimeLeft });
    }
  };
}

export default Timer;
